require("./lib/noConflict");



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/polyfill/noConflict.js
// module id = 159
// module chunks = 0